<template>
    <section class="steps">
        <ul class="steps__way-list">
            <li class="steps__way-item" :class="{ _active: firstStep }">
                <span>1</span>
            </li>
            <li class="steps__way-item" :class="{ _active: secondStep }">
                <span>2</span>
            </li>
            <li class="steps__way-item" :class="{ _active: thirdStep }">
                <span>3</span>
            </li>
            <li class="steps__way-item" :class="{ _active: fourStep }">
                <span>4</span>
            </li>
            <li class="steps__way-item" :class="{ _active: fiveStep }">
                <span>5</span>
            </li>
        </ul>
        <div class="steps__inner">
            <div class="steps__list">
                <section v-if="firstStep" class="steps__item first-step">
                    <h2 class="title">Шаг 1</h2>
                    <p class="sub-title">Размеры</p>
                    <p class="steps__item__text">
                        Замер ширины предполагаемого места размещения изделия производится с точностью до 1 см.
                    </p>
                    <div class="first-step__inner">
                        <img class="first-step__img" :src="(defaultwindow != '') ? defaultwindow : '/assets/img/card/size.jpg'" alt="">
                        <div class="first-step__wrapper">
                            <label for="constructorWidth" class="first-step__label">
                                <span class="first-step__desc">Ширина, см</span>
                                <span class="first-step__input-inner">
                                    <svg class="icon">
                                        <use xlink:href="#window-width"/>
                                    </svg>
                                    <input class="first-step__input" type="text" @keyup="colorsBySize" id="constructorWidth"
                                           placeholder="100" v-model="constructor.width">
                                </span>
                            </label>
                            <label for="constructorHeight" class="first-step__label hidden">
                                <span class="first-step__desc">Высота, см</span>
                                <span class="first-step__input-inner">
                                    <svg class="icon">
                                        <use xlink:href="#window-height"/>
                                    </svg>
                                    <input class="first-step__input" type="text" @keyup="colorsBySize" id="constructorHeight"
                                           placeholder="100" v-model="constructor.height">
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="steps__btn-inner">
                        <button class="btn" @click="getSecondStep" v-if="firstStepBtn">Продолжить</button>
                        <p v-if="!firstStepBtn">Пожалуйста, укажите корректные размеры корниза</p>
                    </div>
                </section>
                <section v-if="secondStep" class="steps__item second-step">
                    <h2 class="title">Шаг 2</h2>
                    <p class="sub-title">Способ подключения</p>
                    <p class="steps__item__text">
                        Выберите способ подключения.
                    </p>
                    <div class="third-step__inner" v-if="methods.length > 0">
                        <div class="third-step__item" v-for="(method, id) of methods">
                            <img class="third-step__item-img" :src="method.custom_image ? method.custom_image : method.image_url"
                                 :alt="method.name + 'фото'">
                            <div class="radio _small">
                                <input class="radio__input radio-second__input" type="radio"
                                       @change="setMethod(method.id)"
                                       v-model="mMethod"
                                       :value="method.id"
                                       :id="id + 'attachMethod'" name="attachMethod">
                                <label class="radio__label radio-second__label link link" :for="id + 'attachMethod'">
                                    {{ method.name }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="steps__btn-inner">
                        <button class="btn _border" @click="getFirstStep">Назад</button>
                        <button class="btn" @click="getThirdStep" v-if="mMethod !== null">Продолжить</button>
                        <p v-if="mMethod === null">Выберите способ подключения</p>
                    </div>
                </section>
                <section v-if="thirdStep" class="steps__item third-step">
                    <h2 class="title">Шаг 3</h2>
                    <p class="sub-title">Серия моторизации</p>
                    <p class="steps__item__text">
                        Выберите Серию моторизации.
                    </p>
                    <div class="third-step__inner">
                        <div class="third-step__item" v-for="(motorization, id) of motorizations" :key="id">
                            <img class="third-step__item-img" :src="motorization.custom_image ? motorization.custom_image : motorization.image_url" :alt="motorization.name + 'фото'">
                            <div class="radio _small">
                                <input class="radio__input radio-second__input" type="radio"
                                       @change="setMotorization(motorization.id)"
                                       v-model="mMotorization"
                                       :value="motorization.id"
                                       :id="id + 'controlItem'" name="controlItem">
                                <label class="radio__label radio-second__label link link" :for="id + 'controlItem'">
                                    {{ motorization.name }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="steps__btn-inner">
                        <button class="btn _border" @click="getSecondStep">Назад</button>
                        <button class="btn" @click="getFourStep" v-if="mMotorization !== null">Продолжить</button>
                        <p v-if="mMotorization === null">Выберите Серию моторизации</p>
                    </div>
                </section>
                <section v-if="fourStep" class="steps__item four-step">
                    <h2 class="title">Шаг 4</h2>
                    <p class="sub-title">Управление</p>
                    <p class="steps__item__text">
                        Выберите управление.
                    </p>
                    <div class="four-step__inner">
                        <div class="four-step__item" v-for="(connection, id) of connections">
                            <img class="four-step__item-img" :src="connection.custom_image ? connection.custom_image : connection.image_url"
                                 :alt="connection.name + 'фото'">
                            <div class="radio _small">
                                <input class="radio__input radio-second__input" type="radio"
                                       @change="setConnection(connection.id)"
                                       v-model="mConnection"
                                       :value="connection.id"
                                       :id="id + 'attachPoint'" name="attachPoint">
                                <label class="radio__label radio-second__label link link" :for="id + 'attachPoint'">
                                    {{ connection.name }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="steps__btn-inner">
                        <button class="btn _border" @click="getThirdStep">Назад</button>
                        <button class="btn" @click="getFiveStep" v-if="mConnection !== null">Продолжить</button>
                        <p v-if="mConnection === null">Выберите управление</p>
                    </div>
                </section>
                <section v-if="fiveStep" class="steps__item five-step">
                    <h2 class="title">Шаг 5</h2>
                    <p class="sub-title">Параметры вашего изделия</p>
                    <div class="five-step__inner">
                        <div class="five-step__item">
                            <span class="five-step__item-term">Изделие:</span>
                            <span class="five-step__item-desc" v-if="name">{{ name }}</span>
                        </div>
                        <div class="five-step__item">
                            <span class="five-step__item-term">Размер (Ш х В, см):</span>
                            <span class="five-step__item-desc">{{ constructor.width }}х{{ constructor.height }}</span>
                        </div>
                        <div class="five-step__item">
                            <span class="five-step__item-term">Способ подключения:</span>
                            <span class="five-step__item-desc">{{product.method.name}}</span>
                        </div>
                        <div class="five-step__item">
                            <span class="five-step__item-term">Серия моторизации:</span>
                            <span class="five-step__item-desc">{{ product.motorization.name }}</span>
                        </div>
                        <div class="five-step__item">
                            <span class="five-step__item-term">Тип управления:</span>
                            <span class="five-step__item-desc">{{ product.connection.name }}</span>
                        </div>
                        <div class="five-step__item _sum">
                            <span class="five-step__item-term">Цена:</span>
                            <span class="five-step__item-desc">{{ product.price }} руб</span>
                        </div>
                    </div>
                    <div class="steps__btn-inner">
                        <button class="btn _border" @click="getFourStep">Назад</button>
                        <button class="btn add-cart" @click="toCart">
                            <span class="add-cart__text">Добавить в корзину</span>
                            <span class="cart">
                                <svg viewBox="0 0 36 26">
                                    <polyline points="1 2.5 6 2.5 10 18.5 25.5 18.5 28.5 7.5 7.5 7.5"></polyline>
                                    <polyline points="15 13.5 17 15.5 22 10.5"></polyline>
                                </svg>
                            </span>
                        </button>
                    </div>
                </section>
            </div>
            <div class="steps-total js-steps-total">
                <img class="steps-total__img" v-if="product.product_image_url" :src="product.product_image_url" alt="">
                <img class="steps-total__img" v-else :src="defaultimg" alt="">
                <div class="steps-total__inner">
                    <div class="steps-total__item _active">
                        <span class="steps-total__item-term">Изделие:</span>
                        <span class="steps-total__item-desc"  v-if="name">{{ name }}</span>
                    </div>
                    <div class="steps-total__item _active">
                        <span class="steps-total__item-term">Размер (Ш х В, см):</span>
                        <span class="steps-total__item-desc">
                            {{ constructor.width }}х{{ constructor.height }}
                        </span>
                    </div>
                    <div :class="'steps-total__item'+(product.method.id ? ' _active' : '')">
                        <span class="steps-total__item-term">Способ подключения:</span>
                        <span class="steps-total__item-desc">{{product.method.name}}</span>
                    </div>
                    <div :class="'steps-total__item'+(product.motorization.id ? ' _active' : '')">
                        <span class="steps-total__item-term">Серия моторизации:</span>
                        <span class="steps-total__item-desc _active">{{ product.motorization.name }}</span>
                    </div>
                    <div :class="'steps-total__item'+( product.connection.id ? ' _active' : '')">
                        <span class="steps-total__item-term">Тип управления:</span>
                        <span class="steps-total__item-desc _active">{{ product.connection.name }}</span>
                    </div>
                    <div class="steps-total__sum">
                        <span class="steps-total__sum-item">Цена:</span>
                        <span class="steps-total__sum-item">{{ product.price }} руб.</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'CorniceConstructor',
    props: ['id', 'name', 'defaultimg', 'defaultwindow'],
    mounted() {
        this.colorsBySize();
        window.addEventListener('scroll', this.stickyConstructorTotal, {passive: true});
    },
    created () {
        window.addEventListener('scroll', this.stickyConstructorTotal);
    },
    destroyed() {
        window.removeEventListener('scroll', this.stickyConstructorTotal);
    },
    methods: {
        colorsBySize() {
            this.$http.post('/api/products/cornices/' + this.id + '/builder/set', this.constructor)
                .then(res => {
                    this.methods = res.data.available.methods;
                    this.product = res.data.product;
                    this.firstStepBtn = true;
                })
                .catch(error => {
                    this.firstStepBtn = false;
                });
        },
        setMethod(id) {
            this.constructor.method = id;
            this.$http.post('/api/products/cornices/'+this.id+'/builder/set', this.constructor).then(res => {
                this.motorizations = res.data.available.motorizations;
                this.product = res.data.product;
            });
        },
        setMotorization(id) {
            this.constructor.motorization = id;
            this.$http.post('/api/products/cornices/'+this.id+'/builder/set', this.constructor).then(res => {
                this.connections = res.data.available.connections;
                this.product = res.data.product;
            });
        },
        setConnection(id) {
            this.constructor.connection = id;
            this.$http.post('/api/products/cornices/'+this.id+'/builder/set', this.constructor).then(res => {
                this.product = res.data.product;
            });
        },
        toCart() {
            this.$http.post('/api/cart/composite/cornice/'+this.id, this.constructor).then(res => {
                this.$eventBus.$emit('cart.increase');
            });
            document.querySelectorAll('.add-cart').forEach(button => button.addEventListener('click', e => {
                if(!button.classList.contains('loading')) {
                    button.classList.add('loading');
                    setTimeout(() => button.classList.remove('loading'), 3700);
                }
            }));
            setTimeout(() => {
                location.replace('/cart/order');
            }, 1500)
        },
        formatPrice(p) {
          return new Intl.NumberFormat('ru-RU').format(p)
        },
        getFirstStep() {
            this.mMethod = null;
            this.constructor.method = null;
            this.motorizations = [];
            this.product.method =  {
                name: 'выберите способ подключения'
            };
            this.$http.post('/api/products/cornices/'+this.id+'/builder/set', this.constructor).then(res => {
                this.product = res.data.product;
            });
            let stepsList = document.querySelector('.steps__list');
            this.firstStep = true;
            this.secondStep = false;
            window.scroll(0, stepsList.offsetTop - 60);
        },
        getSecondStep() {
            this.mMotorization = null;
            this.constructor.motorization = null;
            this.connections = [];
            this.product.motorization =  {
                name: 'выберите серию моторизации'
            };
            this.$http.post('/api/products/cornices/'+this.id+'/builder/set', this.constructor).then(res => {
                this.product = res.data.product;
            });
            let stepsList = document.querySelector('.steps__list');
            this.firstStep = false;
            this.secondStep = true;
            this.thirdStep = false;
            window.scroll(0, stepsList.offsetTop - 60);
        },
        getThirdStep() {
            this.mConnection = null;
            this.product.connection = {
                name: 'выберите тип управления'
            };
            this.constructor.connection = null;
            this.$http.post('/api/products/cornices/'+this.id+'/builder/set', this.constructor).then(res => {
                this.product = res.data.product;
            });
            let stepsList = document.querySelector('.steps__list');
            this.secondStep = false;
            this.thirdStep = true;
            this.fourStep = false;
            window.scroll(0, stepsList.offsetTop - 60);
        },
        getFourStep() {
            let stepsList = document.querySelector('.steps__list');
            this.thirdStep = false;
            this.fourStep = true;
            this.fiveStep = false;
            window.scroll(0, stepsList.offsetTop - 60);
        },
        getFiveStep() {
            let stepsList = document.querySelector('.steps__list');
            this.fourStep = false;
            this.fiveStep = true;
            window.scroll(0, stepsList.offsetTop - 60);
        },
        stickyConstructorTotal() {
            this.$nextTick(function () {
                this.scrollPosition = window.scrollY;
                let constructorTotal = document.querySelector('.js-steps-total');
                if (window.innerWidth >= 992 && this.scrollPosition > 410) {
                    constructorTotal.classList.add("_sticky");
                } else {
                    constructorTotal.classList.remove("_sticky");
                }
            });
        }
    },
    data() {
        return {
            scrollPosition: null,
            footerHeight: null,
            constructor: {
                width: 50,
                height: 40,
            },
           connections: [],
            product: {
                price: 0,
                method: {
                    name: 'выберите метод подключения'
                },
                connection: {
                    name: 'выберите тип подключения'
                },
                motorization: {
                    name: 'выберите серию моторизации'
                },
            },
            mOptions: [],
            mMethod: null,
            mConnection: null,
            methods: [],
            mMotorization: null,
            motorizations: [],
            firstStep: true,
            firstStepBtn: false,
            secondStep: false,
            secondStepBtn: false,
            thirdStep: false,
            fourStep: false,
            fiveStep: false,
        }
    },

}
</script>
